export const NUMBER_OF_EMPLOYEES = [
  "1 - 10",
  "11 - 50",
  "51 - 100",
  "101 - 500",
  "501 - 1000",
  "1000 - Above",
];

export const NUMBER_OF_EMPLOYEES_OPTIONS = NUMBER_OF_EMPLOYEES.map((item) => ({
  label: item,
  value: item,
}));

export const examTypeArray = [
  "Left knee | In Chair",
  "Left knee | On the Floor",
  "Right knee | In Chair",
  "Right knee | On the Floor",
];

export const minValuesArray = [
  "20 to 40",
  "0 to 20",
  "-20 to -1",
  "- 50 to - 21",
  "below -50",
];

export const athleteMinValuesArray = [
  "20 to 200",
  "11 to 20",
  "0 to 10",
  "-1 to -10",
  "-11 to -20",
  "below -20",
];

export const enum RecoveryPlanItem {
  activeExtension = "activeExtension",
  passiveExtension = "passiveExtension",
  activeFlexion = "activeFlexion",
  passiveFlexion = "passiveFlexion",
  examCadence = "examCadence",
  examGoals = "examGoals",
  contralateralExamCadence = "contralateralExamCadence",
}
